<template lang="pug">
  m-table(
    store-name="documentstatuses"
    :headers="headers"
    :query-filter="queryFilter"
  )
</template>

<script>
import MTable from '~/components/modules/tables/m-table'

export default {
  name: 'BlockDocumentStatuses',
  components: { MTable },
  props: {
    documentId: {
      type: String,
      default: null
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'User',
          valueFormatter: status =>
            this._.get(status, 'user.name') || this._.get(status, 'user.email'),
          sortable: false,
          filterable: false
        },
        {
          text: 'Organization',
          component: 'e-html-insert',
          valueFormatter: status =>
            status.organization
              ? this._.get(status, 'organization.name') +
                '<br>' +
                `<small>${this._.get(status, 'organization.edrpou')}</small>`
              : null,
          sortable: false,
          filterable: false
        },
        {
          text: 'Status',
          value: 'status',
          component: 'e-documents-status',
          sortable: false,
          filterable: false
        }
      ]
    },
    queryFilter() {
      return {
        'document.id': this.documentId
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
